import { COLORS } from "shared/consts";

export const ArrowRight = () => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                                     width="16.000000" height="16.000000"
                                     fill="none">
    <path id="Union"
          d="M0.147432 3.6463L3.8141 0L4.51923 0.709073L1.20908 4.00084L4.51923 7.29261L3.8141 8.00168L0.147432 4.35538C0.0530614 4.26153 8.19496e-18 4.13393 0 4.00084C-8.19496e-18 3.86775 0.0530614 3.74015 0.147432 3.6463Z"
          fill={COLORS.FG.MUTED} fillOpacity="0.550000012" fillRule="evenodd"
          transform="matrix(-1,0,0,1,10.5192,3.99988)"/>
</svg>
